<template>
  <div class="products Offers">
    <div class="container">
      <div class="row">
        <!-- Categorias -->
        <div class="col-md-3 order-md-1 mb-4">
          <product-filter
            :categories="categories"
            :subcategories="subcategories"
            :sellers="sellers"
            :cate="cate_filter"
            :subcate="subcate_filter"
            :titulo_interno="internal_name_es"
            :brands="brands"
            :calibers="calibers"
          />
        </div>
        <div class="col-md-9 order-md-2">
          <div :class="[mensaje === '' ? 'd-none' : 'alert alert-success']" role="alert">
            <button type="button" class="close" data-dismiss="alert" @click="ocultar()">
              &times;</button
            ><strong>{{ mensaje }}</strong>
          </div>
          <div :class="[mensaje_error === '' ? 'd-none' : 'alert alert-danger']" role="alert">
            <button type="button" class="close" data-dismiss="alert" @click="ocultar()">
              &times;</button
            ><strong>{{ mensaje_error }}</strong>
          </div>

          <template v-if="product_duplicate.length == 0 || products_list.length == 0"> </template>
          <template v-else>
            <div class="row" v-if="show_paginado">
              <div class="col-md-12">
                <div style="float: left; padding-right: calc(0.5%);">
                  <small>Mostrando pagina {{ current_page }} de {{ final_page }}</small>
                </div>
                <!-- Paginado -->
                <div style="float: right; padding-right: calc(0.5%);">
                  <nav>
                    <ul
                      role="menubar"
                      aria-disabled="false"
                      aria-label="Pagination"
                      class="pagination b-pagination pagination-sm"
                    >
                      <template v-if="current_page == 1">
                        <li role="none presentation" class="page-item disabled">
                          <a
                            role="menuitem"
                            tabindex="-1"
                            aria-label="Goto next page"
                            target="_self"
                            class="page-link"
                            ><span aria-hidden="true" class="page-selector">«</span></a
                          >
                        </li>
                      </template>
                      <template v-else>
                        <li role="none presentation" class="page-item" @click="listadoPagina(1)">
                          <a
                            role="menuitem"
                            tabindex="-1"
                            aria-label="Goto next page"
                            target="_self"
                            class="page-link"
                            ><span aria-hidden="true" class="page-selector">«</span></a
                          >
                        </li>
                      </template>
                      <template v-if="current_page > 1">
                        <li
                          role="none presentation"
                          class="page-item"
                          aria-hidden="true"
                          @click="listadoPagina(current_page - 1)"
                        >
                          <span class="page-link page-selector">‹</span>
                        </li>
                      </template>
                      <template v-else>
                        <li role="none presentation" class="page-item disabled" aria-hidden="true">
                          <span class="page-link page-selector">‹</span>
                        </li>
                      </template>
                      <li
                        v-for="page in pages"
                        :key="page"
                        role="none presentation"
                        :class="['page-item', page === current_page ? 'active' : '']"
                        @click="listadoPagina(page)"
                      >
                        <a
                          role="menuitemradio"
                          tabindex="-1"
                          aria-label="Goto page 2"
                          aria-checked="false"
                          aria-posinset="2"
                          aria-setsize="4"
                          target="_self"
                          class="page-link page-selector"
                          >{{ page }}</a
                        >
                      </li>
                      <template v-if="current_page == final_page">
                        <li role="none presentation" class="page-item disabled">
                          <a
                            role="menuitem"
                            tabindex="-1"
                            aria-label="Goto next page"
                            target="_self"
                            class="page-link"
                            ><span aria-hidden="true" class="page-selector">›</span></a
                          >
                        </li>
                      </template>
                      <template v-else>
                        <li
                          role="none presentation"
                          class="page-item"
                          @click="listadoPagina(current_page + 1)"
                        >
                          <a
                            role="menuitem"
                            tabindex="-1"
                            aria-label="Goto next page"
                            target="_self"
                            class="page-link"
                            ><span aria-hidden="true" class="page-selector">›</span></a
                          >
                        </li>
                      </template>
                      <template v-if="current_page == final_page">
                        <li role="none presentation" class="page-item disabled">
                          <a
                            role="menuitem"
                            tabindex="-1"
                            aria-label="Goto next page"
                            target="_self"
                            class="page-link"
                            ><span class="page-selector" aria-hidden="true">»</span></a
                          >
                        </li>
                      </template>
                      <template v-else>
                        <li
                          role="none presentation"
                          class="page-item"
                          @click="listadoPagina(final_page)"
                        >
                          <a
                            role="menuitem"
                            tabindex="-1"
                            aria-label="Goto next page"
                            target="_self"
                            class="page-link"
                            ><span class="page-selector" aria-hidden="true">»</span></a
                          >
                        </li>
                      </template>
                    </ul>
                  </nav>
                </div>
              </div>

              <div class="col-md-12">
                <!-- <h4 class="mb-3">Billing address</h4> -->
                <card-loader :loopCount="12" v-if="loading" />
                <products-list :products_list="product_duplicate" />
              </div>

              <div class="col-md-12">
                <div style="float: left; padding-right: calc(0.5%);">
                  <small>Mostrando pagina {{ current_page }} de {{ final_page }}</small>
                </div>
                <!-- Paginado -->
                <div style="float: right; padding-right: calc(0.5%);">
                  <nav>
                    <ul
                      role="menubar"
                      aria-disabled="false"
                      aria-label="Pagination"
                      class="pagination b-pagination pagination-sm"
                    >
                      <template v-if="current_page == 1">
                        <li role="none presentation" class="page-item disabled">
                          <a
                            role="menuitem"
                            tabindex="-1"
                            aria-label="Goto next page"
                            target="_self"
                            class="page-link"
                            ><span aria-hidden="true" class="page-selector">«</span></a
                          >
                        </li>
                      </template>
                      <template v-else>
                        <li role="none presentation" class="page-item" @click="listadoPagina(1)">
                          <a
                            role="menuitem"
                            tabindex="-1"
                            aria-label="Goto next page"
                            target="_self"
                            class="page-link"
                            ><span aria-hidden="true" class="page-selector">«</span></a
                          >
                        </li>
                      </template>
                      <template v-if="current_page > 1">
                        <li
                          role="none presentation"
                          class="page-item"
                          aria-hidden="true"
                          @click="listadoPagina(current_page - 1)"
                        >
                          <span class="page-link page-selector">‹</span>
                        </li>
                      </template>
                      <template v-else>
                        <li role="none presentation" class="page-item disabled" aria-hidden="true">
                          <span class="page-link page-selector">‹</span>
                        </li>
                      </template>
                      <li
                        v-for="page in pages"
                        :key="page"
                        role="none presentation"
                        :class="['page-item', page === current_page ? 'active' : '']"
                        @click="listadoPagina(page)"
                      >
                        <a
                          role="menuitemradio"
                          tabindex="-1"
                          aria-label="Goto page 2"
                          aria-checked="false"
                          aria-posinset="2"
                          aria-setsize="4"
                          target="_self"
                          class="page-link page-selector"
                          >{{ page }}</a
                        >
                      </li>
                      <template v-if="current_page == final_page">
                        <li role="none presentation" class="page-item disabled">
                          <a
                            role="menuitem"
                            tabindex="-1"
                            aria-label="Goto next page"
                            target="_self"
                            class="page-link"
                            ><span aria-hidden="true" class="page-selector">›</span></a
                          >
                        </li>
                      </template>
                      <template v-else>
                        <li
                          role="none presentation"
                          class="page-item"
                          @click="listadoPagina(current_page + 1)"
                        >
                          <a
                            role="menuitem"
                            tabindex="-1"
                            aria-label="Goto next page"
                            target="_self"
                            class="page-link"
                            ><span aria-hidden="true" class="page-selector">›</span></a
                          >
                        </li>
                      </template>
                      <template v-if="current_page == final_page">
                        <li role="none presentation" class="page-item disabled">
                          <a
                            role="menuitem"
                            tabindex="-1"
                            aria-label="Goto next page"
                            target="_self"
                            class="page-link"
                            ><span class="page-selector" aria-hidden="true">»</span></a
                          >
                        </li>
                      </template>
                      <template v-else>
                        <li
                          role="none presentation"
                          class="page-item"
                          @click="listadoPagina(final_page)"
                        >
                          <a
                            role="menuitem"
                            tabindex="-1"
                            aria-label="Goto next page"
                            target="_self"
                            class="page-link"
                            ><span class="page-selector" aria-hidden="true">»</span></a
                          >
                        </li>
                      </template>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <TwoModules></TwoModules>
    <News></News>
  </div>
</template>

<script>
import TwoModules from '@/components/products/TwoModules.vue';
import News from '@/components/products/Guia.vue';
import ProductsList from '@/components/products/ProductsList';
import CardLoader from '@/components/shared/CardLoader';
import ProductFilter from '@/views/Catalog/components/ProductFilter/ProductFilter';
import axios from 'axios';
import _ from 'lodash';
import { config_settings } from '@/config.js';

//HTTP ERROR STATUS
const NOT_FOUND = 404;

export default {
  name: 'allProducts',
  components: { ProductsList, CardLoader, ProductFilter, TwoModules, News },
  data() {
    return {
      imgPreUrl: config_settings.PHOTO_SERVER_URL + '/',
      cod_sub_sec: 1,
      nom_sub_sec_es: '',
      nom_sub_sec_en: '',
      internal_name_es: '',
      internal_name_en: '',
      desc_sub_section_es: '',
      desc_sub_section_en: '',
      section: '',
      url_1st_image: 'products/empty-img',
      url_2nd_image: 'products/empty-img',
      url_3rd_image: 'products/empty-img',
      url_4th_image: 'products/empty-img',
      url_5th_image: 'products/empty-img',
      type_1st_image: 'image',
      type_2nd_image: 'image',
      type_3rd_image: 'image',
      type_4th_image: 'image',
      type_5th_image: 'image',
      text1_es: '',
      text1_en: '',
      text2_es: '',
      text2_en: '',
      text3_es: '',
      text3_en: '',
      orientation: '',
      url_es: '',
      url_en: '',
      order_sub_section: '',
      id_position_menu: '',
      url_video: '',
      type: '',
      categories: [],
      subcategories: [],
      calibers: [],
      brands: [],
      sellers: [],
      products_list: [],
      product_duplicate: [],
      loading: false,
      pages: [],
      current_page: 1,
      final_page: 1,
      crit: 12, //number of products per page
      cate_filter: this.$route.params.cate,
      subcate_filter: this.$route.params.subcate,
      subcategoria: this.$route.params.subcate,
      categoria: this.$route.params.cate,
      id_brand: '',
      id_caliber: '',
      criterio: '',
      criterio_categoria: '',
      mensaje: '',
      mensaje_error: '',

      show_paginado: false,
      filter_category: false,
    };
  },
  methods: {
    ocultar() {
      this.mensaje = '';
      this.mensaje_error = '';
    },

    obtener_sub_section_data() {
      axios
        .get(config_settings.RESOURCE_SERVER_URL + '/GET/sub_sections/' + this.cod_sub_sec)
        .then((response) => {
          this.nom_sub_sec_es = response.data.nom_sub_sec_es;
          this.nom_sub_sec_en = response.data.nom_sub_sec_en;
          this.internal_name_es = response.data.internal_name_es;
          this.internal_name_en = response.data.internal_name_en;
          this.desc_sub_section_es = response.data.desc_sub_section_es;
          this.desc_sub_section_en = response.data.desc_sub_section_en;
          this.section = response.data.section;
          this.url_1st_image = response.data.url_1st_image;
          this.url_2nd_image = response.data.url_2nd_image;
          this.url_3rd_image = response.data.url_3rd_image;
          this.url_4th_image = response.data.url_4th_image;
          this.url_5th_image = response.data.url_5th_image;
          this.type_1st_image = response.data.type_1st_image;
          this.type_2nd_image = response.data.type_2nd_image;
          this.type_3rd_image = response.data.type_3rd_image;
          this.type_4th_image = response.data.type_4th_image;
          this.type_5th_image = response.data.type_5th_image;
          this.text1_es = response.data.text1_es;
          this.text1_en = response.data.text1_en;
          this.text2_es = response.data.text2_es;
          this.text2_en = response.data.text2_en;
          this.text3_es = response.data.text3_es;
          this.text3_en = response.data.text3_en;
          this.orientation = response.data.orientation;
          this.url_es = response.data.url_es;
          this.url_en = response.data.url_en;
          this.order_sub_section = response.data.order_sub_section;
          this.id_position_menu = response.data.id_position_menu;
          this.url_video = response.data.url_video;
          this.type = response.data.type;
        })
        .catch((error) => {
          console.log('error');
        });
    },

    scroll_inicio() {
      window.scrollTo(0, 0);
    },

    listar_productos_catalogo() {
      this.loading = true;
      this.filter_category = false;
      var url = '';

      if (this.categoria !== undefined && this.subcategoria !== undefined) {
        url = '/GET/catalog/products?xPag=' + this.crit + '&cat=' + this.subcategoria;
      } else if (this.subcategoria !== undefined) {
        url = '/GET/catalog/products?xPag=' + this.crit + '&cat=' + this.subcategoria;
      } else if (this.categoria !== undefined && this.subcategoria === undefined) {
        this.filter_category = true;
        this.subcate_filter = undefined;
        url = '/GET/catalog/productsxcategory?xPag=' + this.crit + '&cat=' + this.categoria;
      } else if (this.categoria == undefined && this.subcategoria == undefined) {
        this.categoria = '';
        this.subcategoria = '';
        this.subcate_filter = '';
        this.filter_category = false;
        this.$parent.setSearch_subcategory(0, 'Todas las categorías', 0);
        url = '/GET/catalog/products?xPag=' + this.crit;
      }

      axios
        .get(config_settings.RESOURCE_SERVER_URL + url)
        .then((response) => {
          this.loading = false;
          this.products_list = response.data.products;
          this.product_duplicate = response.data.products;
          this.pages = response.data.visible_pages;
          this.final_page = response.data.final_page;
          this.current_page = 1;
          this.mensaje_error = '';
          this.mensaje = '';
          this.show_paginado = true;
          if (
            (this.categoria == undefined || this.categoria == '') &&
            (this.subcategoria == undefined || this.subcategoria == '')
          ) {
            this.listar_calibres();
            this.listar_marcas();
          } else if (
            this.categoria !== undefined &&
            (this.subcategoria === undefined || this.subcategoria === 0)
          ) {
            this.listar_calibresxcate(this.categoria);
            this.listar_marcasxate(this.categoria);
          } else if (this.categoria !== undefined && this.subcategoria !== undefined) {
            this.listar_calibresxsubcate(this.subcategoria);
            this.listar_marcasxsubcate(this.subcategoria);
          }
        })
        .catch((error) => {
          this.products_list = [];
          this.product_duplicate = [];
          this.loading = false;
          this.mensaje_error = 'No se encontraron resultados de la busqueda filtrada.';
          this.mensaje = '';
          this.show_paginado = true;
        });
    },

    listadoPagina(page) {
      this.loading = true;
      if (this.filter_category) {
        console.log('filter category es true');
        var category_string = '';
        var criterio_category_string = '';
        if (this.categoria != '') {
          category_string = '&&cat=' + this.categoria;
        }
        if (this.criterio_categoria != '') {
          criterio_category_string = '&&crit=' + this.criterio_categoria;
        }

        if (this.id_caliber != '' || this.id_brand != '') {
          var url =
            '/GET/catalog/products-2xcategory?xPag=' +
            this.crit +
            category_string +
            criterio_category_string +
            '&&nPag=' +
            page +
            '';

          if (this.id_caliber != '') {
            url = url + '&&caliber=' + this.id_caliber;
          }
          if (this.id_brand != '') {
            url = url + '&&brand=' + this.id_brand;
          }

          axios
            .get(config_settings.RESOURCE_SERVER_URL + url)
            .then((response) => {
              var arreglo = response.data.products;
              if (arreglo.length == 0) {
                this.listadoPagina(page - 1);
              }
              this.loading = false;
              this.products_list = response.data.products;
              this.product_duplicate = response.data.products;
              this.pages = response.data.visible_pages;
              this.final_page = response.data.final_page;
              this.current_page = page;
              this.mensaje_error = '';
              this.mensaje = '';
              this.show_paginado = true;
              this.scroll_inicio();
            })
            .catch((error) => {
              this.loading = false;
              this.show_paginado = false;
              if (error.response.status === NOT_FOUND) {
                this.listadoPagina(page - 1);
              } else {
                toastr.error(error.response.data.details, error.response.data.message, {
                  iconClass: 'customer-danger',
                });
                this.mensaje_error = 'No se encontraron resultados de la busqueda filtrada.';
                this.mensaje = '';
              }
            });
        } else {
          axios
            .get(
              config_settings.RESOURCE_SERVER_URL +
                '/GET/catalog/productsxcategory?xPag=' +
                this.crit +
                category_string +
                criterio_category_string +
                '&&nPag=' +
                page +
                '',
            )
            .then((response) => {
              var arreglo = response.data.products;
              if (arreglo.length == 0) {
                this.listadoPagina(page - 1);
              }
              this.loading = false;
              this.products_list = response.data.products;
              this.product_duplicate = response.data.products;
              this.pages = response.data.visible_pages;
              this.final_page = response.data.final_page;
              this.current_page = page;
              this.mensaje_error = '';
              this.mensaje = '';
              this.show_paginado = true;
              this.scroll_inicio();
            })
            .catch((error) => {
              this.loading = false;
              this.show_paginado = false;
              if (error.response.status === NOT_FOUND) {
                this.listadoPagina(page - 1);
              } else {
                toastr.error(error.response.data.details, error.response.data.message, {
                  iconClass: 'customer-danger',
                });
                this.mensaje_error = 'No se encontraron resultados de la busqueda filtrada.';
                this.mensaje = '';
              }
            });
        }
      } else {
        console.log('filter category es false');
        var subcategoria_string = '';
        var criterio_string = '';
        if (this.subcategoria != '') {
          subcategoria_string = '&&cat=' + this.subcategoria;
        }
        if (this.criterio != '') {
          criterio_string = '&&crit=' + this.criterio;
        }

        if (this.id_caliber != '' || this.id_brand != '') {
          var url = '/GET/catalog/products-2?xPag=' + this.crit + subcategoria_string;

          if (this.id_caliber != '') {
            url = url + '&&caliber=' + this.id_caliber;
          }
          if (this.id_brand != '') {
            url = url + '&&brand=' + this.id_brand;
          }

          axios
            .get(
              config_settings.RESOURCE_SERVER_URL + url + criterio_string + '&&nPag=' + page + '',
            )
            .then((response) => {
              var arreglo = response.data.products;
              if (arreglo.length == 0) {
                this.listadoPagina(page - 1);
              }
              this.loading = false;
              this.products_list = response.data.products;
              this.product_duplicate = response.data.products;
              this.pages = response.data.visible_pages;
              this.final_page = response.data.final_page;
              this.current_page = page;
              this.mensaje_error = '';
              this.mensaje = '';
              this.scroll_inicio();
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === NOT_FOUND) {
                this.listadoPagina(page - 1);
              } else {
                toastr.error(error.response.data.details, error.response.data.message, {
                  iconClass: 'customer-danger',
                });
                this.mensaje_error = 'No se encontraron resultados de la busqueda filtrada.';
                this.mensaje = '';
              }
            });
        } else {
          axios
            .get(
              config_settings.RESOURCE_SERVER_URL +
                '/GET/catalog/products?xPag=' +
                this.crit +
                subcategoria_string +
                criterio_string +
                '&&nPag=' +
                page +
                '',
            )
            .then((response) => {
              var arreglo = response.data.products;
              if (arreglo.length == 0) {
                this.listadoPagina(page - 1);
              }
              this.loading = false;
              this.products_list = response.data.products;
              this.product_duplicate = response.data.products;
              this.pages = response.data.visible_pages;
              this.final_page = response.data.final_page;
              this.current_page = page;
              this.mensaje_error = '';
              this.mensaje = '';
              this.scroll_inicio();
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === NOT_FOUND) {
                this.listadoPagina(page - 1);
              } else {
                toastr.error(error.response.data.details, error.response.data.message, {
                  iconClass: 'customer-danger',
                });
                this.mensaje_error = 'No se encontraron resultados de la busqueda filtrada.';
                this.mensaje = '';
              }
            });
        }
      }
    },

    listar_categorias() {
      axios
        .get(config_settings.RESOURCE_SERVER_URL + '/GET/catalog/categories')
        .then((response) => {
          this.categories = response.data;
        })
        .catch((error) => {});
    },

    listar_subcategorias(valor_categoria) {
      axios
        .get(
          config_settings.RESOURCE_SERVER_URL +
            '/GET/catalog/categories/' +
            valor_categoria +
            '/subcategories',
        )
        .then((response) => {
          this.subcategories = response.data.subcategories;
        })
        .catch((error) => {});
    },

    filtrar_lista(valor_subcategoria, valor_criterio) {
      console.log('Que fue');
      this.loading = true;
      this.filter_category = false;
      axios
        .get(
          config_settings.RESOURCE_SERVER_URL +
            '/GET/catalog/products?cat=' +
            valor_subcategoria +
            '&&crit=' +
            valor_criterio +
            '&&xPag=' +
            this.crit,
        )
        .then((response) => {
          this.loading = false;
          this.product_duplicate = response.data.products;
          this.pages = response.data.visible_pages;
          this.final_page = response.data.final_page;
          this.current_page = 1;
          this.subcategoria = valor_subcategoria;
          this.criterio = valor_criterio;
          this.mensaje_error = '';
          this.mensaje = '';
          this.id_brand = '';
          this.id_caliber = '';
          this.listar_calibresxsubcate(valor_subcategoria);
          this.listar_marcasxsubcate(valor_subcategoria);
        })
        .catch((error) => {
          this.product_duplicate = [];
          this.mensaje_error = 'No se encontraron resultados de la busqueda filtrada.';
          this.mensaje = '';
          this.loading = false;
        });
    },

    filtrar_lista_categoria(valor_categoria, valor_criterio) {
      this.loading = true;
      this.filter_category = true;
      axios
        .get(
          config_settings.RESOURCE_SERVER_URL +
            '/GET/catalog/productsxcategory?cat=' +
            valor_categoria +
            '&&crit=' +
            valor_criterio +
            '&&xPag=' +
            this.crit,
        )
        .then((response) => {
          this.loading = false;
          this.product_duplicate = response.data.products;
          this.pages = response.data.visible_pages;
          this.final_page = response.data.final_page;
          this.current_page = 1;
          this.categoria = valor_categoria;
          this.criterio_categoria = valor_criterio;
          this.mensaje_error = '';
          this.mensaje = '';
          this.id_brand = '';
          this.id_caliber = '';
          this.listar_calibresxcate(valor_categoria);
          this.listar_marcasxate(valor_categoria);
        })
        .catch((error) => {
          this.product_duplicate = [];
          this.mensaje_error = 'No se encontraron resultados de la busqueda filtrada.';
          this.mensaje = '';
          this.loading = false;
        });
    },

    filtrar_lista_marca_caliber(valor_subcategoria, valor_marca, valor_calibre, valor_criterio) {
      console.log('Que fue');
      this.loading = true;
      this.filter_category = false;

      var url =
        '/GET/catalog/products-2?cat=' +
        valor_subcategoria +
        '&&crit=' +
        valor_criterio +
        '&&xPag=' +
        this.crit;

      if (valor_calibre != '') {
        url = url + '&&caliber=' + valor_calibre;
      }
      if (valor_marca != '') {
        url = url + '&&brand=' + valor_marca;
      }

      axios
        .get(config_settings.RESOURCE_SERVER_URL + url)
        .then((response) => {
          this.loading = false;
          this.product_duplicate = response.data.products;
          this.pages = response.data.visible_pages;
          this.final_page = response.data.final_page;
          this.current_page = 1;
          this.subcategoria = valor_subcategoria;
          this.criterio = valor_criterio;
          this.id_caliber = valor_calibre;
          this.id_brand = valor_marca;
          this.mensaje_error = '';
          this.mensaje = '';
          this.listar_calibresxsubcate(valor_subcategoria);
          this.listar_marcasxsubcate(valor_subcategoria);
        })
        .catch((error) => {
          this.product_duplicate = [];
          this.mensaje_error = 'No se encontraron resultados de la busqueda filtrada.';
          this.mensaje = '';
          this.loading = false;
        });
    },

    filtrar_lista_categoria_marca_calibre(
      valor_categoria,
      valor_marca,
      valor_calibre,
      valor_criterio,
    ) {
      this.loading = true;
      this.filter_category = true;

      var url = '/GET/catalog/products-2xcategory?cat=' + valor_categoria + '&&xPag=' + this.crit;

      if (valor_marca != '' && valor_marca != undefined) {
        url = url + '&&brand=' + valor_marca;
      }
      if (valor_calibre != '' && valor_marca != undefined) {
        url = url + '&&caliber=' + valor_calibre;
      }
      console.log(valor_categoria + ' Rocky raccon ' + url);

      url = url + '&&crit=' + valor_criterio;

      axios
        .get(config_settings.RESOURCE_SERVER_URL + url)
        .then((response) => {
          this.loading = false;
          this.product_duplicate = response.data.products;
          this.pages = response.data.visible_pages;
          this.final_page = response.data.final_page;
          this.current_page = 1;
          this.categoria = valor_categoria;
          this.criterio_categoria = valor_criterio;
          this.mensaje_error = '';
          this.mensaje = '';
          this.id_caliber = valor_calibre;
          this.id_brand = valor_marca;
          this.listar_calibresxcate(valor_categoria);
          this.listar_marcasxate(valor_categoria);
        })
        .catch((error) => {
          this.product_duplicate = [];
          this.mensaje_error = 'No se encontraron resultados de la busqueda filtrada.';
          this.mensaje = '';
          this.loading = false;
        });
    },

    listar_calibres() {
      axios
        .get(config_settings.RESOURCE_SERVER_URL + '/GET/calibers/only_enabled')
        .then((response) => {
          this.calibers = response.data;
        })
        .catch((error) => {});
    },

    listar_calibresxcate(cate) {
      axios
        .get(
          config_settings.RESOURCE_SERVER_URL + '/GET/category/' + cate + '/calibers/only_enabled',
        )
        .then((response) => {
          this.calibers = response.data;
        })
        .catch((error) => {
          this.calibers = [];
        });
    },

    listar_calibresxsubcate(subcate) {
      axios
        .get(
          config_settings.RESOURCE_SERVER_URL +
            '/GET/subcategory/' +
            subcate +
            '/calibers/only_enabled',
        )
        .then((response) => {
          this.calibers = response.data;
        })
        .catch((error) => {
          this.calibers = [];
        });
    },

    listar_marcas() {
      axios
        .get(config_settings.RESOURCE_SERVER_URL + '/GET/brands/only_enabled')
        .then((response) => {
          this.brands = response.data;
        })
        .catch((error) => {});
    },

    listar_marcasxate(cate) {
      axios
        .get(config_settings.RESOURCE_SERVER_URL + '/GET/category/' + cate + '/brands/only_enabled')
        .then((response) => {
          this.brands = response.data;
        })
        .catch((error) => {});
    },

    listar_marcasxsubcate(subcate) {
      axios
        .get(
          config_settings.RESOURCE_SERVER_URL +
            '/GET/subcategory/' +
            subcate +
            '/brands/only_enabled',
        )
        .then((response) => {
          this.brands = response.data;
        })
        .catch((error) => {});
    },
  },

  created() {
    //this.getAllProducts();
    this.scroll_inicio();
    this.obtener_sub_section_data();
    this.listar_productos_catalogo();
    this.listar_categorias();
    this.listar_calibres();
    this.listar_marcas();
  },

  watch: {
    $route: function(route) {
      if (route.params.cate !== undefined && route.params.subcate !== undefined) {
        this.categoria = route.params.cate;
        this.subcategoria = route.params.subcate;
        this.subcate_filter = route.params.subcate;
        this.scroll_inicio();
        this.listar_productos_catalogo();
      } else if (route.params.subcate !== undefined) {
        this.categoria = route.params.cate;
        this.subcategoria = route.params.subcate;
        this.subcate_filter = route.params.subcate;
        this.scroll_inicio();
        this.listar_productos_catalogo();
      } else if (route.params.cate !== undefined && route.params.subcate === undefined) {
        this.categoria = route.params.cate;
        this.cate_filter = route.params.cate;
        this.subcategoria = undefined;
        this.listar_productos_catalogo();
      } else if (route.params.cate == undefined && route.params.subcate == undefined) {
        this.categoria = '';
        this.subcategoria = '';
        this.subcate_filter = '';
        this.scroll_inicio();
        this.obtener_sub_section_data();
        this.$parent.setSearch_subcategory(0, 'Todas las categorías');
        this.listar_productos_catalogo();
        this.listar_categorias();
      }

      this.id_brand = '';
      this.id_caliber = '';
    },
  },
};
</script>

<style lang="scss" src="./Offers.scss"></style>
